import { site, addressLine } from "@/config/site";
import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const sections = [
  {
    title: "Who we are",
    body: `North Ember Painting is a painting company based in Delta, British Columbia, Canada (${addressLine}). You can reach us at ${site.phone} or ${site.email}. This policy explains how we handle personal information collected through this website, in line with the principles of Canada's Personal Information Protection and Electronic Documents Act (PIPEDA) and British Columbia's Personal Information Protection Act (PIPA).`,
  },
  {
    title: "What we collect",
    body: "When you submit an estimate request or contact form, we collect the details you provide: your name, phone number, email address, property address or postal code, project details, and any photos you choose to upload. We collect only what we need to respond to your enquiry and prepare an estimate.",
  },
  {
    title: "How we use it",
    body: "Your information is used to respond to your request, discuss your project, prepare estimates, and schedule work if you choose to proceed. We do not sell, rent or trade your personal information, and we do not use it for unrelated marketing without your consent.",
  },
  {
    title: "How it is stored and protected",
    body: "Submissions are delivered to our business email and stored in a secured database as a backup. Access is restricted, submissions are never publicly listed, and uploaded photos are stored with randomized names that are not publicly accessible. Reasonable safeguards are used to protect your information.",
  },
  {
    title: "Service providers",
    body: "Form submissions are delivered using a transactional email service provider, and this website is hosted by a third-party platform. These providers process information only as needed to deliver their services to us.",
  },
  {
    title: "Analytics and cookies",
    body: "This site loads analytics only if you give consent through the cookie banner. Declining consent means no analytics are collected. Essential site functionality does not depend on analytics cookies.",
  },
  {
    title: "Your rights",
    body: `You may request access to the personal information we hold about you, ask for corrections, or ask us to delete it, subject to legal and business record requirements. To make a request, email ${site.email} or call ${site.phone}.`,
  },
  {
    title: "Retention",
    body: "We keep enquiry records only as long as needed to respond to you, complete any work, and meet ordinary business and legal record-keeping needs, after which they are deleted or anonymized.",
  },
  {
    title: "Changes to this policy",
    body: "If this policy changes, the updated version will be posted on this page. Continued use of the site after changes means you accept the updated policy.",
  },
];

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy | North Ember Painting — Delta, BC"
        description="How North Ember Painting collects, uses, stores and protects your personal information, in line with PIPEDA and BC PIPA principles."
        path="/privacy"
      />
      <PageHero eyebrow="Legal" title="Privacy Policy" intro={`Last updated: July 2026 · ${site.name}, Delta, BC`} />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <Reveal>
            <div className="space-y-10">
              {sections.map((s, i) => (
                <div key={s.title}>
                  <h2 className="font-display text-xl font-semibold text-slate-900">
                    {i + 1}. {s.title}
                  </h2>
                  <p className="mt-3 text-base leading-relaxed text-slate-600">{s.body}</p>
                </div>
              ))}
              <div className="rounded-2xl border border-amber-200/70 bg-amber-50/60 p-6 text-sm leading-relaxed text-slate-600">
                <strong className="font-semibold text-slate-800">Note for the business owner:</strong> this policy
                was drafted as a practical starting point for a BC small business. It should be reviewed by a
                qualified legal professional before being relied upon.
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
